import styled from 'styled-components';

import { black } from 'constants/color';

export const StyledCaption = styled.h3`
  color: ${black};
  font-size: 15px;
  margin: 5px 0 0 0;
`;
